export default {
  currentContactData: null,
};
